import { Directive, ElementRef, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { APPCONFIG } from '../../config';
@Directive({ selector: '[myAutoCloseMobileNav]' })

export class AutoCloseMobileNavDirective implements OnInit {
  el: ElementRef;
  router: Router;
  constructor(el: ElementRef, router: Router) {
    this.el = el;
    this.router = router;
  }

  ngOnInit() {
    const $body = $('#body');

    if (APPCONFIG.AutoCloseMobileNav) {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          setTimeout(() => {
            $body.removeClass('sidebar-mobile-open');
          }, 0);
        }
      });
    }

  }
}



// WEBPACK FOOTER //
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/layout/sidenav/auto-close-mobile-nav.directive.ts